import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { PRODUCT } from "../data/catalog";

const CartContext = createContext(null);
const KEY = "markhor-cart";

const load = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const value = useMemo(() => {
    const add = (colorId, qty = 1) =>
      setItems((prev) => {
        const found = prev.find((i) => i.colorId === colorId);
        if (found) return prev.map((i) => (i.colorId === colorId ? { ...i, qty: i.qty + qty } : i));
        return [...prev, { colorId, qty }];
      });
    const update = (colorId, qty) =>
      setItems((prev) => (qty <= 0 ? prev.filter((i) => i.colorId !== colorId) : prev.map((i) => (i.colorId === colorId ? { ...i, qty } : i))));
    const count = items.reduce((s, i) => s + i.qty, 0);
    return { items, add, update, clear: () => setItems([]), count, subtotal: count * PRODUCT.price, open, setOpen };
  }, [items, open]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);
